export function getLowercaseContentType(response) {
  if (!response) return null;
  return response.headers.get("content-type").toLowerCase();
}
